
export const firebaseConfig = {
    apiKey: "AIzaSyAMoZfggaBmiGmP0oJd0uZYUPPmVkCj9fM",
    authDomain: "sme-triage.firebaseapp.com",
    projectId: "sme-triage",
    storageBucket: "sme-triage.appspot.com",
    messagingSenderId: "225208423192",
    appId: "1:225208423192:web:eaed95a2772328f09b446d"
};
